import { Routes } from '@angular/router';
import { TeamListComponent } from './teams/team-list/team-list.component';
import { PeopleListComponent } from './people-list/people-list.component';
import { RoleListComponent } from './role-list/role-list.component';
import { HomepageComponent } from './homepage/homepage.component';
import { SkillListComponent } from './skill-list/skill-list.component';
import { PeopleComponent } from './people/people.component';
import { TeamComponent } from './teams/team/team.component';
import { MapComponent } from './map/map.component';
import { AuthGuard } from './_helper/auth.guard';
import { RoleComponent } from './role/role.component';
import { SkillComponent } from './skill/skill.component';
import { AccountComponent } from './user/account/account.component';
import { RoleGuard } from './_helper/role.guard';
import { AdminDashboardComponent } from './admin/admin-dashboard/admin-dashboard.component';
import { UsersListComponent } from './admin/users/users-list/users-list.component';

export const routes: Routes = [
    { path: '', component: HomepageComponent, canActivate: [AuthGuard]},
    { path: 'teams/:id', component: TeamComponent,canActivate: [AuthGuard] },
    { path: 'teams', component: TeamListComponent,canActivate: [AuthGuard] },
    { path: 'peoples/:id', component: PeopleComponent,canActivate: [AuthGuard] }, 
    { path: 'peoples', component: PeopleListComponent,canActivate: [AuthGuard] },
    { path: 'roles/:id', component: RoleComponent,canActivate: [AuthGuard] },
    { path: 'roles', component: RoleListComponent,canActivate: [AuthGuard] },
    { path: 'skills/:id', component: SkillComponent,canActivate: [AuthGuard] },
    { path: 'skills', component: SkillListComponent,canActivate: [AuthGuard] },
    { path: 'map', component: MapComponent,canActivate: [AuthGuard] },
    { path: 'user/account', component: AccountComponent,canActivate: [AuthGuard] },
    {
      path: 'admin',
      children: [
        { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
        {
            path: 'dashboard',
            component: AdminDashboardComponent,
            canActivate: [AuthGuard, RoleGuard],
            data: { roles: ['super_admin'] }
        },
        {
            path: 'users',
            component: UsersListComponent,
            canActivate: [AuthGuard, RoleGuard],
            data: { roles: ['super_admin'] }
        }
      ]
    },
    { path: 'auth', loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule)}
  ];
